import React, { useMemo } from "react";
import { num } from "@/lib/format";

const HOUR_LABELS = Array.from({ length: 24 }, (_, h) => h);

function HeatmapRow({ date, values, peak }) {
  return (
    <div className="flex items-center">
      <div className="w-14 shrink-0 text-[9px] text-[#9CA3AF]">
        {new Date(`${date}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
      </div>
      {values.map((v, h) => (
        <div
          key={`${date}-${h}`}
          className="flex-1 h-3 mx-[1px] rounded-[2px]"
          title={`${date} ${h}:00 · ${num(v, 1)}`}
          style={{ background: v > 0 ? `rgba(21,111,91,${0.12 + (v / peak) * 0.88})` : "#F3F4F6" }}
        />
      ))}
    </div>
  );
}

export function Heatmap({ hourly }) {
  const { dates, matrix, peak } = useMemo(() => {
    const map = new Map();
    let max = 0;
    hourly.forEach((h) => {
      if (!map.has(h.date)) map.set(h.date, Array(24).fill(0));
      map.get(h.date)[h.hour] = h.val;
      if (h.val > max) max = h.val;
    });
    return { dates: Array.from(map.keys()), matrix: map, peak: max || 1 };
  }, [hourly]);

  if (dates.length === 0) return <div className="h-56 flex items-center justify-center text-sm text-[#9CA3AF]">No interval data</div>;

  return (
    <div className="overflow-x-auto" data-testid="energy-heatmap">
      <div className="min-w-[520px]">
        <div className="flex">
          <div className="w-14 shrink-0" />
          {HOUR_LABELS.map((h) => (
            <div key={h} className="flex-1 text-center text-[8px] text-[#9CA3AF]">
              {h % 3 === 0 ? h : ""}
            </div>
          ))}
        </div>
        <div className="mt-1 space-y-[2px] max-h-64 overflow-y-auto">
          {dates.map((d) => (
            <HeatmapRow key={d} date={d} values={matrix.get(d)} peak={peak} />
          ))}
        </div>
      </div>
    </div>
  );
}
